import { render, staticRenderFns } from "./KCAdd.vue?vue&type=template&id=6781922e&scoped=true&"
import script from "./KCAdd.vue?vue&type=script&lang=js&"
export * from "./KCAdd.vue?vue&type=script&lang=js&"
import style0 from "./KCAdd.vue?vue&type=style&index=0&id=6781922e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6781922e",
  null
  
)

export default component.exports